<template>
  <div id="subscribe">
    <p>
      Welcome to the new Netvfy dashboard!<br />
      DynVPN is being deprecated and this new platform is taking over.<br />
      <br />
      For help, please email us at help@netvfy.com<br />
      For documentation, please visit <a href="https://doc.netvfy.com" target="_blank">https://doc.netvfy.com</a>.<br />
      <br />Happy Networking!
    </p>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'Subscribe'
}
</script>
